/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const CapabilityDevelopment = ({
    actionSteps,
}: Partial<{
    actionSteps: string;
}>) => (
    <>
        {actionSteps && (
            <Row>
                <ValueCell label="Action steps" value={actionSteps} />
            </Row>
        )}
    </>
);

export default CapabilityDevelopment;
